import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut, faCameraRetro, faBars, faTimes, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom';
import './menuLateral.css'
import { ENUM_QUERY_PARAMS } from '../../utils/Enumerados';

const MenuLateral = ({ menuItems, selecionaMenu }) => {

    const navigate = useNavigate();
    const [openMenuResponsive, setOpenMenuResponsive] = useState(false)

    const [nombrePerfil, setNombrePerfil] = useState('')
    const [usuarioPerfil, setUsuarioPerfil] = useState('')

    useEffect(() => {
        let usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage)
            console.log(usuarioLocalStorageObj)
            setNombrePerfil(`${usuarioLocalStorageObj.nombres} ${usuarioLocalStorageObj.apellidos}`)
            setUsuarioPerfil(usuarioLocalStorageObj.usuario)
        }
    }, [])

    const actionLogout = () => {
        sessionStorage.clear();
        navigate(`/zona-agendate?${ENUM_QUERY_PARAMS.LOGOUT}=true`);
    }

    const handleSelectManuDasboard = (itemMenu) => {
        selecionaMenu(itemMenu)
        setOpenMenuResponsive(false)
    }

    return (
        <>
            <div className='div-menu-upper-container-padre'>
                <div className='div-menu-upper-container'>
                    <div className='p-menu-lateral-responsive-container'>
                        <div className='p-menu-lateral-responsive-icon'>
                            <FontAwesomeIcon icon={faUserCircle} className='icon-perfil-responsive' />
                        </div>
                        <div className='p-menu-lateral-responsive-texts'>
                            <p className='p-nombre-perfil'>{nombrePerfil}</p>
                            <p className='p-usuario-perfil'>{usuarioPerfil}</p>
                        </div>
                    </div>
                    {
                        openMenuResponsive ?
                            <>
                                <FontAwesomeIcon className='icon-menu-bars-dashboard' icon={faTimes} onClick={() => setOpenMenuResponsive(!openMenuResponsive)} />
                            </>
                            :
                            <>
                                <p className='p-landing-menu-bars mx-3'> Menú </p>
                                <FontAwesomeIcon className='icon-menu-bars-dashboard' icon={faBars} onClick={() => setOpenMenuResponsive(!openMenuResponsive)} />
                            </>
                    }
                </div>
                <div className='div-dashboard-menu-container-responsive'>
                    <div className={openMenuResponsive ? 'div-dashboard-menu-active' : 'div-dashboard-menu'} >
                        {
                            menuItems.map((itemMenu, index) => {
                                return (
                                    <div key={index} className={`${itemMenu.className}-responsive`} onClick={() => handleSelectManuDasboard(itemMenu)} >
                                        <FontAwesomeIcon icon={itemMenu.iconMenu} className='icon-menu-lateral' />
                                        <p className='mx-2'>{itemMenu.menuLabel} </p>
                                    </div>
                                )
                            })
                        }
                        <div className='div-menu-cerrar-sesion-responsive' >
                            <button name='logout' className='btn btn-link a-buttom-dashboard adjust-btn' onClick={actionLogout}>
                                <FontAwesomeIcon icon={faSignOut} className='icon-menu-lateral-responsive' />
                                <p className='mx-1 p-cerrar-sesion-responsive'>Cerrar sesión </p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="div-menu-lateral-container">
                <div className=''>
                    <div className='div-image-info-perfil-container'>
                        <div className='div-image-info-perfil'>
                            <img src='https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png' className='image-info-perfil' />
                        </div>
                        <FontAwesomeIcon className='icon-camera-update-perfil' icon={faCameraRetro} />
                    </div>
                    <div className='div-info-perfil-dashoard-container'>
                        <p>Agendamiento profesional</p>
                        <p>{nombrePerfil}</p>
                    </div>
                </div>
                <div className='div-menu-items-container'>
                    {
                        menuItems.map((itemMenu, index) => {
                            return (
                                <div key={index} className={itemMenu.className} onClick={() => selecionaMenu(itemMenu)} >
                                    <FontAwesomeIcon icon={itemMenu.iconMenu} className='icon-menu-lateral' />
                                    <p className='mx-2'>{itemMenu.menuLabel} </p>
                                </div>
                            )
                        })
                    }
                    <div className='div-menu-cerrar-sesion' >
                        <button name='logout' className='btn btn-link a-buttom-dashboard adjust-btn' onClick={actionLogout}>
                            <FontAwesomeIcon icon={faSignOut} className='icon-menu-lateral' />
                            <p className='mx-1'>Cerrar sesión </p>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )

}

export default MenuLateral